import angular from 'angular'
import moment from 'moment-timezone'

angular.module('pub.sets.edition', []).controller('SetsEditionCtrl', SetsEditionCtrl)

/** @ngInject */
function SetsEditionCtrl(
  $scope,
  $timeout,
  $q,
  $location,
  $rootScope,
  $stateParams,
  $state,
  SetsService,
  UploadService,
  TagsService,
  TranslatorService,
  PublisherAdminService,
  API,
) {
  var vm = this
  vm.model = {}
  vm.checklistOptions = [
    {
      id: 'clean_slate',
      name: 'Recollect',
    },
    {
      id: 'rank',
      name: 'Rank',
    },
    {
      id: 'first',
      name: 'First',
    },
    {
      id: 'hold',
      name: "Hold 'Em",
    },
  ]

  vm.allStatus = [
    {
      id: 0,
      name: 'Draft',
      disabled: true,
    },
    {
      id: 1,
      name: 'Published',
      disabled: true,
    },
    {
      id: 2,
      name: 'Sold Out',
      disabled: true,
    },
    {
      id: 3,
      name: 'Unavailable',
      disabled: true,
    },
    {
      id: 4,
      name: 'Awaiting Collectible Count',
      disabled: true,
    },
    {
      id: 5,
      name: 'Coming Soon',
      disabled: true,
    },
    {
      id: 6,
      name: 'Archived',
      disabled: true,
    },
  ]

  vm.checklistOption = null
  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.pathImgHWeb = ''
  vm.pathScreen = ''
  vm.loadT = false
  vm.loadH = false
  vm.isUpload = true
  vm.reeditionType = 'Days'
  vm.awaitingCount = false
  vm.status = null
  vm.todo = {
    t: false,
    txt: false,
    tags: false,
    header: false,
    thumbnail: false,
  }
  vm.tags = []
  vm.roys = []
  $('.button-dark').removeClass('is-active')
  $('.button-light').addClass('is-active')
  vm.isOpen = false
  vm.isOpen2 = false
  vm.isOpen3 = false
  vm.tagsList = []
  vm.reeditions = [
    {
      id: 1,
      name: 'None',
    },
    {
      id: 2,
      name: 'Default',
    },
    {
      id: 3,
      name: 'Custom',
    },
  ]

  vm.strategies = [
    {
      id: 0,
      name: 'Standard',
    },
    {
      id: 1,
      name: 'Award',
    },
    {
      id: 2,
      name: 'Collectors Edition',
    },
  ]
  vm.title = null
  vm.setsTranslations = []

  function loadTranslations() {
    SetsService.listTranslations($stateParams.id).then(function (result) {
      vm.setsTranslations = result.results
    })
  }

  loadTranslations()

  $rootScope.$on('tagsList', function (event, data) {
    if (vm.tagsList) {
      data.map(function (item) {
        vm.tagsList.push(item)
      })
      vm.tagsList = _.uniqBy(vm.tagsList, 'id')
    } else {
      vm.tagsList = data
    }
  })

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.openCalendar3 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen3 = true
  }

  PublisherAdminService.getPublisher().then(function (result) {
    vm.publishers = result.results
  })

  SetsService.listProductLines().then(function (result) {
    vm.productLines = result.results
    vm.productLines.unshift({ id: null, t: '(Remove Product Line)' })
  })

  vm.listProductTypes = [
    // { id: 1, t: 'Sticker' },
    { id: 2, t: 'Card' },
    { id: 3, t: 'Figure' },
  ]

  var edit = $location.$$path.indexOf('edit') !== -1
  if (edit) {
    SetsService.getId($stateParams.id).then(function (result) {
      var set = result.results
      vm.model['k-prod'] = set['k-prod']
      // if (vm.model['k-prod'] === 1) {
      //   $('.breadprogress-pagination p')[1].textContent = 'Sticker'
      // } else
      if (vm.model['k-prod'] === 2) {
        $('.breadprogress-pagination p')[1].textContent = 'Card'
      } else if (vm.model['k-prod'] === 3) {
        $('.breadprogress-pagination p')[1].textContent = 'Figure'
      }
      vm.model = set
      vm.title = set.t
      vm.description = set.txt
      if (set.roy !== undefined) {
        for (var i = 0; i < set.roy.length; i++) {
          var item = {
            pubId: set.roy[i]['id-pu'],
            royId: set.roy[i].id,
            roys: [set.roy[i]],
          }
          vm.roys.push(item)

          vm.changePub(item)
        }
      }

      vm.status = vm.model.st
      if (vm.model.st === 4) {
        vm.awaitingCount = true
      }

      if (set['ts-p'] !== undefined && set['ts-p'] !== 0 && set['ts-p'] !== null) {
        set['ts-p'] = set['ts-p'].toString().substring(0, set['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(set['ts-p']))
      }
      if (set['ts-ra'] !== undefined && set['ts-ra'] !== 0 && set['ts-ra'] !== null) {
        set['ts-ra'] = set['ts-ra'].toString().substring(0, set['ts-ra'].toString().length - 3)
        vm.model['ts-ra'] = new Date(parseInt(set['ts-ra']))
      }
      if (
        set['ts-ra-cash'] !== undefined &&
        set['ts-ra-cash'] !== 0 &&
        set['ts-ra-cash'] !== null
      ) {
        set['ts-ra-cash'] = set['ts-ra-cash']
          .toString()
          .substring(0, set['ts-ra-cash'].toString().length - 3)
        vm.model['ts-ra-cash'] = new Date(parseInt(set['ts-ra-cash']))
      }
      vm.model['img-h'] = set['img-h']
      vm.model['img-t'] = set['img-t']
      vm.model['img-ad'] = set['img-ad']
      vm.model['img-ad-web'] = set['img-ad-web']

      vm.model['color-hl'] = set['color-hl']
      vm.model['color-txt'] = set['color-txt']
      vm.model['color-bg'] = set['color-bg']

      vm.model['id-pln'] = set['id-pln']

      vm.glossaryName = set.ch['id-gl']

      vm.pathImgT = set['img-t']
      vm.pathImgHWeb = set['img-h-web']
      vm.pathImgH = set['img-h']
      vm.pathImgAd = set['img-ad']
      vm.pathImgAdWeb = set['img-ad-web']
      vm.isUpload = false
      vm.model.tags = set.tags
      if (vm.model.tags !== undefined) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          vm.tags.push(vm.model.tags[i].id)
        }
      }

      if (set.ttr === 24 || set.ttr === 48 || set.ttr === 72) {
        vm.reeditionSelect = vm.reeditions[1].id
        vm.reeditionType = 'Hours'
      } else if (set.ttr >= 0) {
        vm.reeditionSelect = vm.reeditions[2].id
        vm.ttr = set.ttr
        vm.reeditionType = 'Hours'
      } else {
        vm.reeditionType = 'Days'
        vm.reeditionSelect = vm.reeditions[0].id
      }

      $('#e7').select2('data', vm.model.tags)
      switch (vm.model['st-rel']) {
        case 0:
          vm.setRelease = 'None'
          break
        case 1:
          vm.setRelease = 'Coming Soon'
          break
        case 2:
          vm.setRelease = 'About to Drop'
          break
        case 3:
          vm.setRelease = 'Pre Sale'
          break
        case 4:
          vm.setRelease = 'Available now'
          break
        default:
          vm.setRelease = 'None'
          break
      }
      vm.todo.t = set.t !== ''
      vm.todo.txt = set.txt !== ''
      vm.todo.tags = vm.tags.length > 0
      vm.todo.header = set['img-h'] !== ''
      vm.todo.thumbnail = set['img-t'] !== ''
      $('#breadcrumb a').last().after(vm.model.t)
    })
  } else {
    $('#breadcrumb a').last().after('Create')
  }

  vm.next = function () {
    $state.go('pub.collectibles', { parentId: $stateParams.id }, { reload: true })
  }

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       if (route === 'reload') {
  //         $state.reload()
  //         return
  //       } else {
  //         $state.go(route, { parentId: $stateParams.parentId, id: paramsId })
  //         return
  //       }
  //     }
  //   }

  //   TranslatorService.translateProductAllLanguage(t, txt, vm.glossaryName).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         // if (currentTranslations[i]['id-u']) {
  //         //   continue
  //         // }
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               SetsService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               SetsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               SetsService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               SetsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               SetsService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               SetsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               SetsService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               SetsService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           if (route === 'reload') {
  //             $state.reload()
  //           } else {
  //             $state.go(route, {
  //               parentId: $stateParams.parentId,
  //               id: paramsId,
  //             })
  //           }
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           SetsService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           SetsService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           SetsService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           SetsService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         if (route === 'reload') {
  //           $state.reload()
  //         } else {
  //           $state.go(route, {
  //             parentId: $stateParams.parentId,
  //             id: paramsId,
  //           })
  //         }
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.save = function (isValid) {
    var isHL = true,
      isTXT = true,
      isBG = true

    if (vm.model['color-hl'] !== undefined && vm.model['color-hl'] !== '') {
      isHL = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-hl'])
    }

    if (vm.model['color-txt'] !== undefined && vm.model['color-txt'] !== '') {
      isTXT = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-txt'])
    }

    if (vm.model['color-bg'] !== undefined && vm.model['color-bg'] !== '') {
      isBG = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-bg'])
    }

    if (!isHL) {
      swal('Highlight Color is invalid hexcolor.', '', 'error')
      return
    }

    if (!isTXT) {
      swal('Text Color is invalid hexcolor.', '', 'error')
      return
    }

    if (!isBG) {
      swal('Background Color is invalid hexcolor.', '', 'error')
      return
    }

    var listTags = $('#e7').select2('val')
    var modelTags = []
    if (listTags !== undefined) {
      if (vm.model.tags !== undefined) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          for (var j = 0; j < listTags.length; j++) {
            if (parseInt(listTags[j]) === vm.model.tags[i].id) {
              modelTags.push(vm.model.tags[i])
            }
          }
        }
      }

      for (var i = 0; i < vm.tagsList.length; i++) {
        for (var j = 0; j < listTags.length; j++) {
          if (parseInt(listTags[j]) === vm.tagsList[i].id) {
            modelTags.push(vm.tagsList[i])
          }
        }
      }
    }

    vm.reeditionChange()

    if (vm.model.ttr < 0) {
      swal("You can't add Relative Hours negative", '', 'warning')
      return
    }

    vm.todo.t = vm.model.t !== ''
    vm.todo.txt = vm.model.txt !== ''
    vm.todo.tags = vm.tags.length > 0
    vm.todo.header = vm.model['img-h'] !== ''
    vm.todo.thumbnail = vm.model['img-t'] !== ''

    var model = angular.copy(vm.model)
    if (model['ts-p'] !== undefined && model['ts-p'] !== '' && model['ts-p'] !== null) {
      if (isDate(model['ts-p'])) {
        model['ts-p'].setSeconds(0)
        var date = parseInt(new Date(model['ts-p']).getTime() + '000')
        model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (model['ts-ra'] !== undefined && model['ts-ra'] !== '' && model['ts-ra'] !== null) {
      if (isDate(model['ts-ra'])) {
        model['ts-ra'].setSeconds(0)
        var date = parseInt(new Date(model['ts-ra']).getTime() + '000')
        model['ts-ra'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (
      model['ts-ra-cash'] !== undefined &&
      model['ts-ra-cash'] !== '' &&
      model['ts-ra-cash'] !== null
    ) {
      if (isDate(model['ts-ra-cash'])) {
        model['ts-ra-cash'].setSeconds(0)
        var date = parseInt(new Date(model['ts-ra-cash']).getTime() + '000')
        model['ts-ra-cash'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (vm.awaitingCount) {
      model.st = 4
      model['ts-p'] = null
    } else {
      if (vm.status === 4) {
        model.st = 0
      }
    }

    if (edit) {
      $('#callModalSet').click()
      $('#myModal2').modal('hide')
      SetsService.mintableCollectibles($stateParams.id, model.mint).then(
        function () {
          SetsService.update($stateParams.parentId, $stateParams.id, model).then(function (result) {
            TagsService.addTagSet(result.results.id, modelTags).then(function () {
              toastr.success('Saved')
              // makeTranslation(model.t, model.txt, vm.setsTranslations, result.results.id, 'reload')
              $state.reload()
            })
          })
        },
        function (err) {
          SetsService.update($stateParams.parentId, $stateParams.id, model).then(function (result) {
            TagsService.addTagSet(result.results.id, modelTags).then(function () {
              toastr.success('Saved')
              // makeTranslation(model.t, model.txt, vm.setsTranslations, result.results.id, 'reload')
              $state.reload()
            })
          })
        },
      )
    } else {
      if (!isValid) {
        toastr.warning('Complete all fields!')
        $('html, body').animate({ scrollTop: 0 }, 1000)
        return
      }
      SetsService.save($stateParams.parentId, model).then(function (result) {
        TagsService.addTagSet(result.results.id, modelTags).then(function () {
          toastr.success('Saved. Now you can add images')
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   vm.setsTranslations,
          //   result.results.id,
          //   'pub.channels.sets.edit',
          // )
          $state.go('pub.channels.sets.edit', {
            parentId: $stateParams.parentId,
            id: result.results.id,
          })
          $('html, body').animate({ scrollTop: 0 }, 1000)
        })
      })
    }
  }

  vm.nextEdition = function () {
    SetsService.nextEdition($stateParams.id).then(function () {
      swal('New Edition!', '', 'success')
      window.location.reload()
    })
  }

  vm.ok = function () {
    $state.go($state.current, {}, { reload: true })
  }

  var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT = false
      return
    }

    if (newVal === null) {
      vm.loadT = false
    }

    vm.loadT = true
    UploadService.save('sets', newVal, 'img-t', $stateParams.id).then(function (fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
      vm.pathImgT = fileName
    })
  })

  var watch1 = $scope.$watch('vm.fileImgH', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadH = false
      return
    }

    if (newVal === null) {
      vm.loadH = false
      return
    }

    vm.loadH = true
    UploadService.save('sets', newVal, 'img-h', $stateParams.id).then(function (fileName) {
      vm.loadH = false
      vm.model['img-h'] = fileName
      vm.pathImgH = fileName
    })
  })

  var watch2 = $scope.$watch('vm.cover', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    $('html, body').animate({ scrollTop: 0 }, 'fast')

    UploadService.save('sets', newVal, 'img-c', $stateParams.id).then(function (fileName) {
      swal('Upload complete !')
      var top = $('.preview').height() - 40 - ($('.preview').height() - 40) * 2
      var right = 8
      var left = 5
      $('.iphone-screen').css('margin-top', top).css('margin-right', right).css('margin-left', left)
      vm.pathScreen = fileName
    })
  })

  vm.batchName = 'File name'
  vm.batchProgress = null
  var watch3 = $scope.$watch('vm.batch', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadB = false
      return
    }

    if (newVal === null) {
      vm.loadB = false
      return
    }

    vm.loadB = true
    UploadService.saveBatch('process', newVal, $stateParams.parentId + '_' + $stateParams.id).then(
      function (fileName) {
        vm.batchName = fileName
        vm.batchProgress = null

        var env = ''
        if (
          window.location.href.indexOf('dev') !== -1 ||
          window.location.href.indexOf('localhost') !== -1
        ) {
          env = 'dev'
        } else {
          env = 'prod'
        }

        var payload = {
          Key: 'process/' + fileName,
          Env: env,
        }
        SetsService.processBatch(payload).then(
          function () {
            swal('Upload complete!')
            vm.loadB = false
          },
          function (err) {
            vm.loadB = false

            console.log(err)
            swal('Error in upload batch', err.error, 'error')
          },
        )
      },
    )
  })

  $rootScope.$on('batchUploadProgress', function (event, data) {
    vm.batchProgress = data
    $scope.$apply()
  })

  var watch6 = $scope.$watch("vm.model['ts-p']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch7 = $scope.$watch("vm.model['ts-ra']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch8 = $scope.$watch("vm.model['ts-ra-cash']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate3NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate3LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch9 = $scope.$watch('vm.fileImgHWeb', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadHWeb = false
      return
    }

    if (newVal === null) {
      vm.loadHWeb = false
      return
    }

    vm.loadHWeb = true
    UploadService.save('sets', newVal, 'img-h-web', $stateParams.id).then(function (fileName) {
      vm.loadHWeb = false
      vm.model['img-h-web'] = fileName
      vm.pathImgHWeb = fileName
    })
  })

  vm.changePub = function (item) {
    SetsService.listRoyalties(item.pubId).then(function (result) {
      item.roys = result.results
    })
  }

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
    watch6()
    watch7()
    watch8()
    watch9()
  })

  vm.deleteImage = function (key) {
    switch (key) {
      case 'img-t':
        vm.pathImgT = ''
        break
      case 'img-h-web':
        vm.pathImgHWeb = ''
        break
      case 'img-h':
        vm.pathImgH = ''
        break
    }
    vm.model[key] = ''
  }

  vm.addRoy = function () {
    for (var i = 0; i < vm.roys.length; i++) {
      if (vm.roys[i].royId === 0) {
        swal('You need save a Royalty first', '', 'warning')
        return
      }
    }

    vm.roys.push({
      pubId: 0,
      royId: 0,
    })
  }

  vm.saveRoy = function (item) {
    SetsService.addRoy($stateParams.id, item.royId).then(
      function () {
        toastr.success('Saved')
      },
      function (err) {
        if (err.error.message.indexOf('duplicate key') !== -1) {
          swal('Already exist this Royalty.', '', 'error')
          var countDup = 0
          for (var i = 0; i < vm.roys.length; i++) {
            if (vm.roys[i].royId === item.royId) {
              countDup++
            }
          }

          if (countDup === 2) {
            vm.roys.remove(item)
          }
        }
        return
      },
    )
  }

  vm.removeRoy = function (item) {
    if (item.royId === 0) {
      vm.roys.remove(item)
    } else {
      SetsService.removeRoy($stateParams.id, item.royId).then(
        function () {
          toastr.success('Deleted')
          vm.roys.remove(item)
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.reeditionChange = function () {
    if (vm.reeditionSelect === 2) {
      vm.reeditionType = 'Hours'
      // if (vm.model['k-prod'] === 1) {
      //   vm.model.ttr = 24
      // } else
      if (vm.model['k-prod'] === 2) {
        vm.model.ttr = 48
      } else if (vm.model['k-prod'] === 3) {
        vm.model.ttr = 72
      }
    } else if (vm.reeditionSelect === 3) {
      vm.reeditionType = 'Hours'
      vm.model.ttr = parseInt(vm.ttr)
    } else {
      vm.reeditionType = 'Days'
      vm.model.ttr = null
    }
  }

  vm.isOpenChecklist1 = false
  vm.openCalendarChecklist1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist1 = true
  }

  vm.isOpenChecklist2 = false
  vm.openCalendarChecklist2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist2 = true
  }

  vm.isOpenChecklist3 = false
  vm.openCalendarChecklist3 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist3 = true
  }

  vm.isOpenChecklist4 = false
  vm.openCalendarChecklist4 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist4 = true
  }

  vm.valRankMin = ''
  vm.valRankMax = ''
  vm.createChecklist = function () {
    if (!vm.checklistOption) {
      swal('You must select a option', '', 'warninng')
      return
    }

    if (vm.checklistOption === 'clean_slate') {
      var startsAt
      var endsAt
      if (
        vm.dataChecklist2 !== undefined &&
        vm.dataChecklist2 !== '' &&
        vm.dataChecklist2 !== null
      ) {
        if (isDate(vm.dataChecklist2)) {
          startsAt = new Date(vm.dataChecklist2).toISOString()
        } else {
          startsAt = new Date().toISOString()
        }
      } else {
        startsAt = new Date().toISOString()
      }
      if (
        vm.dataChecklist3 !== undefined &&
        vm.dataChecklist3 !== '' &&
        vm.dataChecklist3 !== null
      ) {
        if (isDate(vm.dataChecklist3)) {
          endsAt = new Date(vm.dataChecklist3).toISOString()
        } else {
          endsAt = ''
        }
      } else {
        endsAt = ''
      }

      SetsService.createChecklistCleanSlate(
        parseInt($stateParams.id),
        'sets',
        startsAt,
        endsAt,
        vm.valRankMin,
        vm.valRankMax,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist2 = null
          vm.dataChecklist3 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Clean slate checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'rank') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      SetsService.createChecklistRank(
        parseInt($stateParams.id),
        'sets',
        expiredAt,
        'Top',
        vm.rankMin,
        vm.rankMax,
        bundleID,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Rank checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'first') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      SetsService.createChecklistRank(
        parseInt($stateParams.id),
        'sets',
        expiredAt,
        'First',
        vm.rankMin,
        vm.rankMax,
        bundleID,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMin = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>First checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'hold') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      SetsService.createChecklistHold(parseInt($stateParams.id), 'sets', expiredAt, bundleID).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += "<h3>Hold 'Em checklist created</h3><br />"
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    }
  }
}
